import { ajax, updateBlockModelCallback } from 'OK/utils/utils';

/**
* Работает как @see PhotoLayerExtension.java, толььо на аноонимке.
* Позволяет открывать фоотолеер без перехоода по ссылке,обновляя лишь блок фотоолеера (hook_Block_PopLayerPhoto)
*/

function handleOnNavigate(href) {
    OK.loader.use(['OKCustomJs'], function(){
        OK.Layers.push(href);
        OK.Layers.startLoad();
    });

    ajax({
        type: 'GET',
        url: href
    }, function (redirectLocation) {
        handleOnNavigate(decodeURIComponent(redirectLocation));
    })
    .done(updateBlockModelCallback)
    .done(function () {
        OK.Layers.endLoad();
    });
}

function activate(element) {
    var href = element.getAttribute('href'),
        paramsSeparatorPos = href.indexOf('?');

    if (paramsSeparatorPos !== -1) {
        element.setAttribute('href', href.substr(0, paramsSeparatorPos));
    }

    element.addEventListener('click', function(e) {
        handleOnNavigate(href);

        e.preventDefault();
    }, true);
}

export default { handleOnNavigate, activate };

export { handleOnNavigate, activate };
